<br><br>
<app-gestiones-header-preca [buttonselected]=6 [gestionSeleccionada]="gestionSeleccionada" (selecttab)="selectedtab($event)" (selectParticipante)="selectedparticipante($event)"></app-gestiones-header-preca>
<div class="container-fluid">
    <div class="row table-full">
        <div class="col-md-4">
            <div class="item-title">
                <h1>DEUDOR</h1>
            </div>
            <div class="item">
                <div class="row" style="height: 100%;">
                    <div class="col-md-8">
                        <h2 class="center-relative">
                            DETALLE PRESOLICITUD DEUDOR
                        </h2>
                    </div>
                    <div class="col-md-4">
                        <button type="button" class="btn download-button" (click)="generatePdfPreca(0)">
                            <span class="logo">
                                <img src="../../../assets/icons/combined-shape-20769.png" />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="item-title">
                <h1>CODEUDOR</h1>
            </div>
            <div class="item">
                <div class="row" style="height: 100%;">
                    <div class="col-md-8" >
                        <h2 class="center-relative">
                            DETALLE PRESOLICITUD CODEUDOR
                        </h2>
                    </div>
                    <div class="col-md-4">
                        <button *ngIf="gestionSeleccionada.participante.length==2" type="button" class="btn download-button" (click)="generatePdfPreca(1)" >
                            <span class="logo">
                                <img src="../../../assets/icons/combined-shape-20769.png" />
                            </span>
                        </button>
                        <button *ngIf="gestionSeleccionada.participante.length==1" type="button" class="btn download-button" disabled >
                            <span class="logo">
                                <img src="../../../assets/icons/combined-shape-20769.png" />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="item-title">
                <h1>DICTAMEN</h1>
            </div>
            <div class="item">
                <div class="row" style="height: 100%;">
                    <div class="col-md-8">
                        <h2 class="center-relative">
                            DICTAMEN DE LA SOLICITUD DE CREDITO DEUDOR
                        </h2>
                    </div>
                    <div class="col-md-4">
                        <button type="button" class="btn download-button" (click)="generatePdfDictamen()">
                            <span class="logo">
                                <img src="../../../assets/icons/combined-shape-20769.png" />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>